export const RewardManagerEvents = {
  GetBalance: 'RewardManager.GetBalance',
  BalanceReturned: 'RewardManager.BalanceReturned',

  GetRewardsAddedAfterBlock: 'RewardManager.GetRewardsAddedAfterBlock',
  RewardsAddedAfterBlockReturned:
    'RewardManager.RewardsAddedAfterBlockReturned',

  Withdraw: 'RewardManager.Withdraw',
  WithdrawCompleted: 'RewardManager.WithdrawCompleted',

  GetReward: 'RewardManager.GetReward',
  RewardCompleted: 'RewardManager.RewardCompleted',

  GetRewardsPaid: 'RewardManager.GetRewardsPaid',
  RewardsPaidReturned: 'RewardManager.RewardsPaidReturned',

  GetTotalRewardsPaid: 'RewardManager.GetTotalRewardsPaid',
  TotalRewardsPaidReturned: 'RewardManager.TotalRewardsPaidReturned',
}
